<template>
   <v-layout mb-3 row v-if="show" wrap>
      <v-flex lg12 style="margin-left: -3px;" xs12>
         <v-chip @click="onFilterRowClick('')" style="cursor: pointer !important;">
            <v-avatar style="cursor: pointer;">
               <v-icon size="17">fas fa-filter</v-icon>
            </v-avatar>
            <span style="cursor: pointer;">{{$t('appMsg.filters')}}
                    <span class="font-weight-bold mx-3" v-if="noFilterText">{{noFilterText}}</span>
                </span>
         </v-chip>
         <v-scale-transition group>
            <template v-for="label in pageFilterLabels">
               <v-chip :key="label.field" @click="onFilterRowClick(label.field)">
                  {{label.text}}
               </v-chip>
            </template>
         </v-scale-transition>
      </v-flex>
   </v-layout>
</template>

<script>
   export default {
      name: 'filter-row',

      props: {
         noFilterText: {
            type: String,
            required: false
         },
         autoHide: {
            type: Boolean,
            required: false,
            default: true
         }
      },

      computed: {
         pageFilterLabels () {
            return this.$store.getters.pageFilterLabels;
         },

         show () {
            if (this.autoHide) {
               return this.pageFilterLabels.length;
            }

            return true;
         }
      },

      methods: {
         onFilterRowClick (field) {
            // console.log(field);
            window.getApp.$emit('APP_RIGHT_DRAWER_TOGGLED', this.$route.meta.filterComponent);

         }
      }


   };
</script>




// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/defaultPage/FilterRow.vue